import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TagCompany } from 'src/app/shared/models/company';
import { DateTimezonePipe } from 'src/app/shared/pipes/date-timezone.pipe';
import { BasicService } from 'src/app/shared/services/basic.service';
import { Task } from 'src/app/tasks/shared/models';

import { FiltersService } from '../filters/filters.service';

@Component({
  selector: 'app-task-infos',
  templateUrl: './task-infos.component.html',
  styleUrls: ['./task-infos.component.scss'],
})
export class TaskInfosComponent implements OnChanges, OnInit {
  @Input() task: Task;

  channelName = '';
  team: TagCompany;

  fullDateTime: string;

  accountTypeTranslation = '';

  constructor(
    private basicService: BasicService,
    private dateTimezonePipe: DateTimezonePipe,
    private filtersService: FiltersService
  ) {}

  ngOnChanges(): void {
    const tags = this.filtersService.getRoutingTagsForTaskListFilters();
    this.team = this.task.tags.find(tag => {
      return tag?.group.id === tags[0].id;
    });
  }

  ngOnInit() {
    this.accountTypeTranslation = this.basicService.translate(`account_type/${this.task.site.type_name}`);

    // could be done in template, but tooltip do not accepts ng-template or html
    if (this.task.message.detailed_task_type) {
      this.channelName += this.basicService.translate(
        `message/detailed_task_type/${this.task.message.detailed_task_type}`
      );

      if (this.task.message.facebook_messaging_app_name) {
        this.channelName += ` ${this.basicService.translate('message/via')} : ${
          this.task.message.facebook_messaging_app_name
        }`;
      }
    }

    this.fullDateTime = `${this.dateTimezonePipe.transform(
      this.task.message.created_time,
      'shortDate'
    )} ${this.dateTimezonePipe.transform(this.task.message.created_time, 'mediumTime')}`;
  }
}
